import {css} from 'lit'; export default css`:host{display:inherit;flex-direction:inherit}chameleon-navigation-drawer-item[selected] chameleon-svg{--goto-icon-color:var(--goto-type-color-inverted)}`;
    